import { BehaviorSubject, Observable, combineLatest, map, of } from "rxjs";

import { WISHLIST_ITEMS_SORTING_TYPE, WishlistSortItem } from "../types";

class WishlistSortingManager {
    private sortItems: WishlistSortItem[];
    private currentSortValue$: BehaviorSubject<WISHLIST_ITEMS_SORTING_TYPE>;
    private currentSortItem$: Observable<WishlistSortItem>;

    constructor({
        labelTranslationNamespace,
    }: {
        labelTranslationNamespace: string;
    }) {
        this.sortItems = [
            {
                value: WISHLIST_ITEMS_SORTING_TYPE.recentlyAdded,
                labelTranslationKey: "sort_recently_added",
                labelTranslationNamespace: labelTranslationNamespace,
            },
            {
                value: WISHLIST_ITEMS_SORTING_TYPE.aToZProductTitle,
                labelTranslationKey: "sort_a_to_z_product_title",
                labelTranslationNamespace: labelTranslationNamespace,
            },
            {
                value: WISHLIST_ITEMS_SORTING_TYPE.zToAProductTitle,
                labelTranslationKey: "sort_z_to_a_product_title",
                labelTranslationNamespace: labelTranslationNamespace,
            },
            {
                value: WISHLIST_ITEMS_SORTING_TYPE.highToLowPrice,
                labelTranslationKey: "sort_hight_to_low_price",
                labelTranslationNamespace: labelTranslationNamespace,
            },
            {
                value: WISHLIST_ITEMS_SORTING_TYPE.lowToHighPrice,
                labelTranslationKey: "sort_low_to_high_price",
                labelTranslationNamespace: labelTranslationNamespace,
            },
        ];

        this.currentSortValue$ =
            new BehaviorSubject<WISHLIST_ITEMS_SORTING_TYPE>(
                WISHLIST_ITEMS_SORTING_TYPE.recentlyAdded
            );

        this.currentSortItem$ = this.currentSortValue$.pipe(
            map((currentSortValue) => {
                return (
                    this.sortItems.find(
                        (item) => item.value === currentSortValue
                    ) || {
                        value: WISHLIST_ITEMS_SORTING_TYPE.recentlyAdded,
                        labelTranslationKey: "sort_recently_added",
                        labelTranslationNamespace: labelTranslationNamespace,
                    }
                );
            })
        );
    }

    selectCurrentSortItem() {
        return this.currentSortItem$;
    }

    selectCurrentSortValue() {
        return this.currentSortValue$.asObservable();
    }

    getSortItems() {
        return this.sortItems;
    }

    setCurrentSortValue(value: WISHLIST_ITEMS_SORTING_TYPE) {
        this.currentSortValue$.next(value);
    }
}

export default WishlistSortingManager;
